import React from "react"
import HalfCirclePair from "./HalfCirclePair";
import 'aos/dist/aos.css'; 


function Landing() {
  return (
    <div className="container">
        <div className="row">

        <HalfCirclePair />
       

        </div>
    </div>
      
    
  )
};

export default Landing;
